module.exports = __webpack_public_path__ + "img/background_13.01eba36a.jpg";